<template>
  <div class="core-advantages">
     <div class="section-container">
        <div class="core-title">核心优势</div>
    </div>
    <div class="section-header">
      <p class="sub-title">CORE ADVANTAGES</p>
    </div>
    <div class="card-grid">
      <div class="card-item">
        <div class="card-content">
          <h3 class="card-title">体系完整</h3>
          <p class="card-desc">参与制定多个科技成果评价国家、行业标准。</p>
        </div>
      </div>
      <div class="card-item">
        <div class="card-content">
          <h3 class="card-title">专家智库</h3>
          <p class="card-desc">建设了10000余位高能级专家智库。</p>
        </div>
      </div>
      <div class="card-item">
        <div class="card-content">
          <h3 class="card-title">丰富案例</h3>
          <p class="card-desc">完成多项科技成果评价，涵盖电子信息、新材料等领域。</p>
        </div>
      </div>
      <div class="card-item">
        <div class="card-content">
          <h3 class="card-title">专业团队</h3>
          <p class="card-desc">组建了一支专业、高效的科技成果评价服务团队。</p>
        </div>
      </div>
      <div class="card-item">
        <div class="card-content">
          <h3 class="card-title">国家资源</h3>
          <p class="card-desc">与十余家知名国家级学会合作。</p>
        </div>
      </div>
      <div class="card-item">
        <div class="card-content">
          <h3 class="card-title">高能服务</h3>
          <p class="card-desc">服务内容包括奖励培育服务，及科创属性服务。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CoreAdvantages"
};
</script>

<style scoped>
.core-advantages {
  width: 100%;
  margin: 0 auto;
  max-width: 1600px;
  padding: 50px 10px;
  background-color: #f0f7ff;
  box-sizing: border-box;
}

.section-header {
  text-align: center;
  margin-bottom: 40px;
}
.sub-title {
  font-size: 24px;
  color: #666;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin: 0 auto;
}
.card-item {
  height: 360px;
  background: url('~@/assets/images/ys.png') no-repeat center center;
  background-size: 100% 100%;
  position: relative;
}
.card-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.card-title {
  font-size: 32px;
  font-weight: 600;
  color: #003388;
  margin-top: 87px;
  margin-left: 78px;
}
.card-desc {
  font-size: 22px;
  line-height: 2;
  margin: 30px 80px;
  margin-left: 100px;
  width: 60%;
  color: #000;
}
.section-container {
  width: 100%;
  text-align: center;
}

.core-title {
  font-size: 3rem;    
  font-weight: bold;    
  color: #003388;  
  margin-bottom: 10px;   
}
@media (max-width: 1400px) {
  .card-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .card-title {
    margin-left: 88px;
  }
}
@media (max-width: 1200px) {
  .card-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .card-title {
    margin-left: 68px;
  }
}
@media (max-width: 768px) {
  .card-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  .card-item {
    height: 440px;
    background-size: cover;
  }
  .card-title {
    margin-top: 126px !important;
    margin-left: 100px !important;
    font-size: 26px !important;
  }
  .card-desc {
    margin: 15px 40px !important;
    width: 50%;
    font-size: 26px !important;
    line-height: 1.7 !important;
     margin-left: 100px !important;
  }
  .sub-title {
    font-size: 22px;
  }
 
}
@media (max-width: 700px) {
  .card-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  .card-item {
    height: 240px;
    background-size: cover;
  }
  .card-title {
    margin-top: 50px !important;
    margin-left: 40px !important;
    font-size: 26px !important;
  }
  .card-desc {
    margin: 15px 40px !important;
    width: calc(100% - 120px) !important;
    font-size: 17px !important;
    line-height: 1.7 !important;
  }
  .sub-title {
    font-size: 22px;
  }
  
}

/* 小屏手机：再缩小一点 */
@media (max-width: 380px) {
  .core-advantages{
    padding: 50px 0px;
  }
  .card-item {
    height: 220px;
  }
  .card-title {
    font-size: 24px !important;
  }
  .card-desc {
    font-size: 15px !important;
  }
}

</style>